import LogRocket from "logrocket";
import { UserAttr } from "@services/users";
import setupLogRocketReact from "logrocket-react";

const setupMonitoring = (): void => {
  if (
    process.env.REACT_APP_APP_STAGE === "production" &&
    process.env.REACT_APP_LOGROCKET_APP_ID
  ) {
    LogRocket.init(process.env.REACT_APP_LOGROCKET_APP_ID);
    setupLogRocketReact(LogRocket);
  }
};

const identifyUser = (user: UserAttr): void => {
  if (process.env.REACT_APP_APP_STAGE === "production") {
    LogRocket.identify(user.email, {
      name: user.name,
      email: user.email,
      user_id: user.user_id,
      releaseStage: process.env.REACT_APP_APP_STAGE!,
    });
  }
};

// Default export is necessary for code splitting with Webpack.
// eslint-disable-next-line import/no-default-export
export default { setupMonitoring, identifyUser };
